import { gql, useQuery } from '@apollo/client'
import { RouteComponentProps } from '@reach/router'
import { toFriendlyKitId } from 'helpers/string'
import { DashboardTitle } from './DashboardTitleContext'
import KitDetail, { kitDetailFragment } from './KitDetail'
import { KitByIdQuery, KitByIdQueryVariables } from './__generated__/KitByIdQuery'

const kitByIdQuery = gql`
  query KitByIdQuery($id: ID!) {
    kitById(id: $id) {
      ...KitDetailFragment
    }
  }

  ${kitDetailFragment}
`

const Kit = ({ kitId }: RouteComponentProps<{ kitId: string }>) => {
  const { loading, error, data } = useQuery<KitByIdQuery, KitByIdQueryVariables>(kitByIdQuery, {
    variables: { id: kitId },
  })

  if (loading) return <p>Loading...</p>

  if (error) throw error

  if (!data.kitById) {
    return <p>Not Found</p>
  }

  return (
    <div className="container">
      <DashboardTitle title={`K${toFriendlyKitId(data.kitById.id.replace('Kit-', ''))}`} />
      <KitDetail kit={data.kitById} />
    </div>
  )
}

export default Kit
